exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-2d079fa9] {\n  border: 1px solid #d7d8da;\n}\n.clickable td[data-v-2d079fa9] {\n  font-weight: 500;\n}", ""]);

// exports
